import { render, staticRenderFns } from "./CtkButtonValidate.vue?vue&type=template&id=52108c28&scoped=true&"
import script from "./CtkButtonValidate.vue?vue&type=script&lang=js&"
export * from "./CtkButtonValidate.vue?vue&type=script&lang=js&"
import style0 from "./CtkButtonValidate.vue?vue&type=style&index=0&id=52108c28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52108c28",
  null
  
)

component.options.__file = "CtkButtonValidate.vue"
export default component.exports